//SENTRY
import './plugins/sentry';

// ALPINE
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect'

// PLUGINS
import './plugins/focus-method';
import {fathomEvent} from './plugins/fathom-event';

// COMPONENTS
import './components/screenshot-carousel';
import './components/app/filter-buttons';
import './components/app/modals';

const axios = require('axios').default;

window.axios = axios;
window.Alpine = Alpine;
window.fathomEvent = fathomEvent;

Alpine.plugin(intersect)
Alpine.plugin(focus)

Alpine.start()

